export const URL = {
  CALL_CENTER: "https://pf.kakao.com/_Gmqxcd",
  MY_WOW_MONEY: "https://mypage.wowtv.co.kr/MyBenefit/Cash/Index?menuSeq=518",
  WHAT_IS_WOW_MONEY:
    "https://www.wownet.co.kr/Event/EventInfo/EventView?EVENT_SN=7766&Page=28&sort=desc",
  ROULETTE_EVENT: "https://www.wownet.co.kr/Event/Roulette",
}
